<script>
  import { push } from "svelte-spa-router"

  /**
   * @type {String} - redirect URL
   */
  export let redirectUrl = ""

  /**
   * @type {String} - header name
   */
  export let headerName = ""
</script>

<div class="mb-3 flex items-end justify-between">
  <div class="space-y-1">
    {#if redirectUrl}
      <button
        on:click={() => {
          push(redirectUrl)
        }}
        type="button"
        class="w-16 cursor-pointer select-none text-base font-medium text-gray-200 hover:text-blue-600 focus-visible:text-blue-600 focus-visible:outline-none active:text-blue-500"
        style="text-decoration: none;"
      >
        <span>
          <i class="fa-solid fa-reply" />
          <span>&nbsp;Back&nbsp;</span>
        </span>
      </button>
    {/if}
    <h1 class="select-none text-xl font-bold text-black dark:text-white">
      {headerName}
    </h1>
  </div>
</div>
